import type { Demand } from '@/types/knowledge_graph'
import { DemandCard } from '../components/DemandCard'

interface Props {
  demands: Demand[]
  onUpdateDemand: (demandId: string, changes: Partial<Demand>) => void
}

export function DemandsTab ({ demands, onUpdateDemand }: Props): React.ReactElement {
  const approvedCount = demands.filter((d) => d.review_status === 'approved').length

  return (
    <>
      <div className='section-head'>
        <h3>要求一覧</h3>
        <span className='count'>{demands.length}件 — {approvedCount}件確認済</span>
      </div>
      <div style={{
        fontSize: 11,
        color: 'var(--bp-ink3)',
        marginBottom: 10,
        display: 'flex',
        alignItems: 'center',
        gap: 6
      }}
      >
        内容を確認したらチェックを入れてください。
      </div>
      {demands.length === 0
        ? (
          <div style={{ color: 'var(--bp-ink3)', fontSize: 13 }}>要求がありません</div>
          )
        : (
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>
            {demands.map((d) => (
              <DemandCard
                key={d.id}
                demand={d}
                onUpdate={(changes) => onUpdateDemand(d.id, changes)}
              />
            ))}
          </div>
          )}
    </>
  )
}
